export const buildGetTw = typography => {
  const get = function (type) {
    let withColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let withLineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (withColor && withLineHeight) {
      console.warn(`Use the class "typography-type-${type}" instead of get method`);
      return `typography-type-${type}`;
    }
    if (!withColor && !withLineHeight) {
      console.warn(`Use "typography-default-${type}" instead of get method`);
      return `typography-default-${type}`;
    }
    if (!withColor && withLineHeight) {
      console.warn(`Use "typography-p-${type}" instead of get method`);
      return `typography-lineheighted-${type}`;
    }
    return `typography-colored-${type}`;
  };
  return get;
};
//# sourceMappingURL=getTw.js.map